__turbopack_context__.v({
  "button": "link-module-scss-module__ky_pDG__button",
});
